import { RefObject } from 'preact';

export function smoothScrollTo<T extends HTMLElement>(ref: RefObject<T | null>, offset: number) {
    if (ref.current) {
        const scroll = window.scrollY + ref.current.getBoundingClientRect().top + offset;
        window.scrollTo({ left: 0, top: scroll, behavior: 'smooth' });
    }
}
